// extracted by mini-css-extract-plugin
export default {"bgColorWarning":"#ff877f","whiteColor":"#fff","sortOptions":"SortOptions_sortOptions__Su3Y0"};